import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { ModalVariants } from '@whitbread-eos/atoms';
import { useCallback, useState } from 'react';
import { LoginPIVariant } from '../../LogIn';
import { ResetPasswordPIVariant } from '../../ResetPassword';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AuthContentManagerPIVariant(_ref) {
  var isLoginModalOpen = _ref.isLoginModalOpen,
    toggleLoginModal = _ref.toggleLoginModal,
    labels = _ref.labels,
    headerInfoData = _ref.headerInfoData;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isLoginForm = _useState2[0],
    setIsLoginForm = _useState2[1];
  var _useState3 = useState({
      email: '',
      password: ''
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    loginDefaultValues = _useState4[0],
    setLoginDefaultValues = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    loginDefaultErrors = _useState6[0],
    setLoginDefaultErrors = _useState6[1];
  var getLoginFormState = useCallback((state1, errors1) => {
    setLoginDefaultValues(state1);
    setLoginDefaultErrors(errors1);
  }, [setLoginDefaultValues, setLoginDefaultErrors]);
  var _useState7 = useState({
      email: ''
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    resetPasswordDefaultValues = _useState8[0],
    setResetPasswordDefaultValues = _useState8[1];
  var _useState9 = useState({}),
    _useState0 = _slicedToArray(_useState9, 2),
    resetPasswordDefaultErrors = _useState0[0],
    setResetPasswordDefaultErrors = _useState0[1];
  var getResetPasswordFormState = useCallback((state, errors) => {
    setResetPasswordDefaultValues(state);
    setResetPasswordDefaultErrors(errors);
  }, [setResetPasswordDefaultValues, setResetPasswordDefaultErrors]);
  return _jsx(ModalVariants, {
    onClose: toggleLoginModal,
    isOpen: isLoginModalOpen,
    variant: "default",
    variantProps: {
      title: '',
      delimiter: true,
      sizeSm: 'full'
    },
    updatedWidth: {
      md: 'auto',
      sm: 'full'
    },
    dataTestId: 'Header-Auth',
    children: isLoginForm ? _jsx(LoginPIVariant, {
      setIsLoginForm: setIsLoginForm,
      defaultValues: loginDefaultValues,
      defaultErrors: loginDefaultErrors,
      getFormState: getLoginFormState,
      toggleLoginModal: toggleLoginModal,
      labels: labels,
      headerInfoData: headerInfoData
    }) : _jsx(ResetPasswordPIVariant, {
      setIsLoginForm: setIsLoginForm,
      defaultValues: resetPasswordDefaultValues,
      defaultErrors: resetPasswordDefaultErrors,
      getFormState: getResetPasswordFormState,
      labels: labels
    })
  });
}